import { $ppidAtom } from '@client/core/atoms/config.js';
import fetcher from '@client/core/utils/api/fetcher.js';

import type {
  RetailMediaPayload,
  RetailMediaResponse
} from '../types/index.js';

export class RateLimitError extends Error {
  constructor(message = 'Rate limit exceeded') {
    super(message);
    this.name = 'RateLimitError';
  }
}

const sessionId = crypto.randomUUID();
const MIN_REQUEST_INTERVAL_MS = 1000;
let lastRequestTime = 0;

let visitorId: string | null = null;
export const getVisitorId = () => {
  if (!visitorId) {
    const ppidData = $ppidAtom.get();
    visitorId = ppidData.kevel?.ppId1 || ppidData.kevel?.ppId2 || 'anonymous';
  }
  return visitorId;
};

export async function callApi(
  payload: RetailMediaPayload
): Promise<RetailMediaResponse> {
  // rate limit to prevent too many requests
  const now = Date.now();
  if (now - lastRequestTime < MIN_REQUEST_INTERVAL_MS) {
    throw new RateLimitError('Request too soon after previous request');
  }
  lastRequestTime = now;
  return fetcher<RetailMediaResponse>('/api/retail/sponsored-catalog', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...payload,
      sessionId
    })
  });
}

export async function trackImpressionBackend(
  trackingUrl: string
): Promise<void> {
  try {
    await fetcher('/api/retail/impression', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        trackingUrl,
        sessionId
      })
    });
  } catch (error) {
    console.error('Failed to track impression:', error);
  }
}

export async function trackClickBackend(trackingUrl: string): Promise<void> {
  try {
    await fetcher('/api/retail/click', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        trackingUrl,
        sessionId
      })
    });
  } catch (error) {
    console.error('Failed to track click:', error);
  }
}
